import { Component, Mixins, Emit } from 'vue-property-decorator';
import ViewPage from '@/mixins/Views';
import store from '@/store';
import VueRouter from 'vue-router';
// @ is an alias to /src
@Component
export default class Login extends Mixins(ViewPage) {
  private name = 'login';
}
